<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{ $t('Company') }}</h6>
                                <h1 class="header-title">{{ $t('Roles') }}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'RoleModal'}); data = {}"
                                    class="btn btn-primary"
                                >{{ $t('New role') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <input
                                            type="search"
                                            v-model="query"
                                            class="form-control form-control-flush search no-glow"
                                            :placeholder="$t('Search')"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                    <simple-table :loading="rolesLoading"
                                  :data="filteredRoles"
                                  :columns="columns"
                                  :edit="editRole" :hide-delete-button="true"></simple-table>
                </div>
            </div>
        </div>
        <role-modal id="RoleModal" :model="data"></role-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import SimpleTable from "@/components/SimpleTable";
import { modalMixins } from "@/mixins/modal";
import RoleModal from "@/components/Roles/RoleModal";

export default {
    name: "Roles",
    components: { RoleModal, SimpleTable },
    mixins: [modalMixins],
    data() {
        return {
            query: '',
            data: {},
            exemptServices: ['authentication', 'authManagement', 'auth'],
            columns: [
                {
                    label: 'Role',
                    name: 'role',
                    sortable: true,
                    field: (item) => {
                        return item.role
                    },
                    subtitle(item) {
                        return item.description;
                    }
                }
            ]
        }
    },

    mounted() {
        this.getRoles();
        this.findServices();
    },

    methods: {
        ...mapActions('roles', { getRoles: 'find' }),
        ...mapActions("permissions", { getPermissions: 'find' }),
        ...mapActions("services-list", { findServices: 'find' }),

        editRole(role) {
            this.openModal({ id: 'RoleModal' });
            const { Role } = this.$FeathersVuex;
            new Role({
                model: role,
                _id: 'temp'
            });
        },
    },

    computed: {
        ...mapGetters('roles', { findRolesStore: 'find' }),
        ...mapState('roles', { rolesLoading: 'isFindPending' }),

        filteredRoles() {
            let query = { $sort: { createdAt: 1 }, _id: { $ne: 'temp' } };
            if (this.query) {
                query.$or = [{ role: { $regex: this.query, $options: "i" } }]
            }
            let result = this.findRolesStore({ query: query }).data;
            return result.map(item => Object.assign(item, { can_delete: true, blocked: !item.companyId }));
        }
    }
}
</script>

<style scoped>

</style>
